import schniderImage from '@assets/images/integrations/schneider-electric.jpg';
import atAutomationImage from '@assets/images/integrations/at-automation.jpg';
import iteqImage from '@assets/images/integrations/iteq-key-solutions.jpg';
import assaImage from '@assets/images/integrations/assa-abloy.jpg';
import saltoImage from '@assets/images/integrations/salto.jpg';
import operImage from '@assets/images/integrations/opera.jpg';
import mewsImage from '@assets/images/integrations/mews.jpg';
import airbnbImage from '@assets/images/integrations/airbnb.jpg';
import zkTecoImage from '@assets/images/integrations/zkt-eco.jpg';
import bookingImage from '@assets/images/integrations/booking-com.jpg';
import interlinkImage from '@assets/images/integrations/interlink.jpg';
import hotelSmartersImage from '@assets/images/integrations/hotel-smarters-card.png';

export const electronicCompanies = [
  {
    id: 'inter-link',
    name: 'Interlink',
    description:
      'Interlink is a broadband and digital TV service provider offering a rich catalog of live channels.\n' +
      'Choose Interlink to automatically import the latest channel lineup and metadata directly from their service.',
    image: interlinkImage,
    isConnected: false
  },
  {
    id: 'schneider-electric',
    name: 'Schneider Electric',
    description:
      'Smart building energy and automation systems to control lighting, climate, and power.',
    image: schniderImage,
    isConnected: false
  },
  {
    id: 'at-automation',
    name: 'AT Automation',
    description:
      'Smart device automation for energy-saving, guest comfort, and room control.',
    image: atAutomationImage,
    isConnected: false
  },
  {
    id: 'ZK-Teco',
    name: 'ZK Teco',
    description:
      'Biometric and smart access control systems for enhanced hotel security.',
    image: zkTecoImage,
    isConnected: false
  },
  {
    id: 'ITEQ-Solutions',
    name: 'ITEQ Solutions',
    description:
      'Smart device automation platform that enhances energy efficiency, lighting, and climate control in hotel environments.',
    image: iteqImage,
    isConnected: false
  },
  {
    id: 'Assa-Abloy',
    name: 'Assa Abloy',
    description:
      'Electronic lock systems for hotels, enabling key card and mobile access.',
    image: assaImage,
    isConnected: false
  },
  {
    id: 'Salto',
    name: 'Salto',
    description:
      'Advanced smart access control systems with wireless electronic locks.',
    image: saltoImage,
    isConnected: false
  },
  {
    id: 'Oracle-Opera',
    name: 'Oracle Opera',
    description:
      'Leading property management system for hotels to manage reservations, billing, and operations.',
    image: operImage,
    isConnected: false
  },
  {
    id: 'Mews',
    name: 'Mews',
    description:
      'Cloud-based property management system for modern hotels and hospitality businesses.',
    image: mewsImage,
    isConnected: false
  },
  {
    id: 'Airbnb',
    name: 'Airbnb',
    description:
      'Online marketplace for short-term lodging and vacation rentals.',
    image: airbnbImage,
    isConnected: false
  },

  {
    id: 'booking-com',
    name: 'Booking.com',
    description:
      'Global online travel agency for hotel bookings and guest reservations.',
    image: bookingImage,
    isConnected: false
  }
];

export const hotelSmartersCompanies = [
  {
    id: 'room-tablets',
    name: 'In Room Tablets',
    description:
      'Transform the guest room experience with branded tablets that offer digital menus, service requests, room control (lighting, AC), entertainment, and concierge access — all in one device.',
    image: hotelSmartersImage,
    isConnected: false
  },
  {
    id: 'self-check-in',
    name: 'Self Check In',
    description:
      'Allow guests to skip the front desk with modern self-service kiosks. Guests can check in, receive room keys, and check out with invoice printouts, reducing queues and improving satisfaction.',
    image: hotelSmartersImage,
    isConnected: false
  },
  {
    id: 'internet',
    name: 'Hotel Internet',
    description:
      'Secure, real-time communication for hotel staff. Improve operational efficiency with role-based chat channels, task coordination, alerts, and cross-department collaboration — all in one system.',
    image: hotelSmartersImage,
    isConnected: false
  },
  {
    id: 'PMS',
    name: 'PMS',
    description:
      'A centralized cloud-based PMS that streamlines reservations, guest profiles, billing, housekeeping, and front-desk operations. Seamlessly integrates with other hotel systems and supports both traditional and digital workflows.',
    image: hotelSmartersImage,
    isConnected: false
  },
  {
    id: 'digital-signage-solutions',
    name: 'Digital Signage Solutions',
    description:
      'Dynamic signage system for lobbies, elevators, conference areas, and restaurants. Display schedules, ads, welcome messages, or custom content. Cloud-controlled with scheduling, branding, and multilingual support.',
    image: hotelSmartersImage,
    isConnected: false
  },
  {
    id: 'Mobile App',
    name: 'Mobile App',
    description:
      'Your hotel’s services in guests’ hands. A white-label mobile app for Android and iOS that allows guests to book, check-in, control their room, order F&B, communicate with staff, and access all hotel amenities.',
    image: hotelSmartersImage,
    isConnected: false
  },
  {
    id: 'F&B',
    name: 'F&B',
    description:
      'Digital F&B system integrated with room service and POS. Guests can browse menus, place orders from TVs, tablets, or mobile apps, and receive real-time order updates. Supports upselling and multilingual menus.',
    image: hotelSmartersImage,
    isConnected: false
  },
  {
    id: 'SPA-&-Wellness',
    name: 'SPA & Wellness',
    description:
      'Enable guests to explore spa treatments, check therapist availability, and make appointments digitally. Manage schedules, services, and capacity with ease.',
    image: hotelSmartersImage,
    isConnected: false
  },
  {
    id: 'Meetings-&-Conferences',
    name: 'Meetings & Conferences',
    description:
      'Powerful tools for managing meeting rooms, event scheduling, digital signage for agendas, and guest check-ins. Ideal for hotels with conference spaces, enabling staff and attendees to collaborate efficiently.',
    image: hotelSmartersImage,
    isConnected: false
  },

  {
    id: 'Internal-Staff-Chat',
    name: 'Internal Staff Chat',
    description:
      'Secure, real-time communication for hotel staff. Improve operational efficiency with role-based chat channels, task coordination, alerts, and cross-department collaboration — all in one system.',
    image: hotelSmartersImage,
    isConnected: false
  }
];

export const integrationsTabsData = [
  { label: 'tab_label_integrations', value: 'all-integrations' },
  { label: 'tab_label_add_ons', value: 'hotel-products' }
];
